var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0348 1.9083C11.2172 1.72591 11.4338 1.58123 11.6721 1.48252C11.9104 1.38381 12.1658 1.33301 12.4237 1.33301C12.6817 1.33301 12.9371 1.38381 13.1754 1.48252C13.4137 1.58123 13.6302 1.72591 13.8126 1.9083C13.995 2.0907 14.1397 2.30723 14.2384 2.54553C14.3371 2.78384 14.3879 3.03925 14.3879 3.29719C14.3879 3.55513 14.3371 3.81055 14.2384 4.04885C14.1397 4.28716 13.995 4.50369 13.8126 4.68608L4.43761 14.0611L0.618164 15.1027L1.65983 11.2833L11.0348 1.9083Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditbutton);
export default __webpack_public_path__ + "static/media/editbutton.a9da8393d6c69e6337d35cee8ab526de.svg";
export { ForwardRef as ReactComponent };